
import store_operation from '@/store/mods/caisse/operations'

export default {
    name: 'recouvrements',
    data() {
        return { rappels: [], recherche: '', loading: false, error: false, action_id: null, timer: null }
    },
    computed: {
        rappelsActifs() { return this.rappels.filter(item => item.rappel_actif).length },
        rappelsFiltres() {
            const texte = this.recherche.trim().toLocaleLowerCase('fr')
            return texte ? this.rappels.filter(item =>
                [item.facture_reference, item.facture_assurance, item.facture_societe, item.personne_contactee, item.action_attendue]
                    .some(value => String(value || '').toLocaleLowerCase('fr').includes(texte))) : this.rappels
        }
    },
    mounted() {
        this.actualiser()
        this.timer = window.setInterval(() => this.actualiser(), 60000)
    },
    beforeDestroy() {
        if (this.timer) window.clearInterval(this.timer)
    },
    methods: {
        async actualiser() {
            this.loading = true
            this.error = false
            try {
                const response = await store_operation.getRappelsRecouvrement(this.getClinicTimezone())
                this.rappels = response.data || []
            } catch (_) {
                this.error = true
            } finally {
                this.loading = false
            }
        },
        async terminer(id) {
            this.action_id = id
            try {
                await store_operation.terminerSuiviRecouvrement(id)
                await this.actualiser()
            } catch (_) {
                this.error = true
            } finally {
                this.action_id = null
            }
        }
    }
}


